import { useState } from 'react';
import { PriceDropZonesEnum } from '@enums/price-drop/price-zones';
import { useContextSelector } from 'use-context-selector';
import { PriceDropContext } from '@context/price-drop-context';
import { BannerBoxProps } from './box/BannerBox';

type PriceDropBannerBoxPresenterObject = {
  isPriceZoneLoading: boolean;
  isLearnMoreModalOpen: boolean;
  onCloseLearnMoreModal: () => void;
  priceZone: PriceDropZonesEnum;
} & Omit<BannerBoxProps, 'className' | 'description' | 'title' | 'titleIcon' | 'variant'>;

export const usePriceDropBannerBoxPresenter = (): PriceDropBannerBoxPresenterObject => {
  const [isLearnMoreModalOpen, setIsLearnMoreModalOpen] = useState(false);
  const recommendedPrice = useContextSelector(PriceDropContext, (a) => a.recommendedPrice);
  const recommendedPriceFormatted = useContextSelector(PriceDropContext, (a) => a.recommendedPriceFormatted);
  const updateSellerPrice = useContextSelector(PriceDropContext, (a) => a.updateSellerPrice);
  const priceZone = useContextSelector(PriceDropContext, (a) => a.priceZone);
  const isPriceZoneLoading = useContextSelector(PriceDropContext, (a) => a.isPriceZoneLoading);
  const priceDetails = useContextSelector(PriceDropContext, (a) => a.priceDetails);
  const updateDebouncedSellerPrice = useContextSelector(PriceDropContext, (a) => a.updateDebouncedSellerPrice);
  const debouncedSellerPrice = useContextSelector(PriceDropContext, (a) => a.debouncedSellerPrice);

  const priceDetailsErrorMessage = debouncedSellerPrice <= 0 || priceDetails?.errorMessage;

  return {
    priceZone: (!priceDetailsErrorMessage && priceZone?.id) || null,
    isPriceZoneLoading: isPriceZoneLoading,
    isLearnMoreModalOpen,
    recommendedPrice: recommendedPriceFormatted,
    showLearnMoreButton: true,
    showRecommendedPriceButton: priceZone?.showApplyRecommendedPrice ?? false,
    onClickRecommendedPrice: () => {
      updateSellerPrice(recommendedPrice);
      updateDebouncedSellerPrice(recommendedPrice);
    },
    onClickLearnMore: () => {
      setIsLearnMoreModalOpen(true);
    },
    onCloseLearnMoreModal: () => {
      setIsLearnMoreModalOpen(false);
    },
  };
};
